const initialState = {
  notifications: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "notify":
      return {
        ...state,
        notifications: [...state.notifications, action.notification],
      };
    case "closeNotification":
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.id
        ),
      };
    default:
      return state;
  }
};

export { reducer, initialState };
